import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "the-wrapper-public-v2"
};
const _hoisted_2 = {
  class: "right-side"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_alert = _resolveComponent("app-alert");
  const _component_big_radial_background = _resolveComponent("big-radial-background");
  const _component_logo_with_description = _resolveComponent("logo-with-description");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_app_alert), _createElementVNode("div", _hoisted_1, [_createVNode(_component_big_radial_background), !_ctx.$slots['left-side'] ? (_openBlock(), _createBlock(_component_logo_with_description, {
    key: 0
  })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "left-side"), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])])], 64);
}